import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import {
  PlusCircleFilled,
  SearchOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { sortBy } from "lodash";
import { Button, Flex, List, Skeleton } from "antd";
import { SketchPicker } from "react-color";
import plusDottedIcon from "../../../assets/icons/plus-dotted-icon.svg";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";

import {
  AddNewMaintenanceType,
  MaintainaceTypeList,
} from "../../../redux/actions/maintenanceAction";

import { useSelector, useDispatch } from "react-redux";

export const MaintenanceType = ({
  setShowModal,
  showModal,
  formik,
  maintenanceTypeList,
  setTypeOfMaintenance,
  typeOfMaintenance,
}) => {
  const maintenanceType = [
    { id: "1", name: "Breakdown", color: "#FF7E57B3" },
    { id: "2", name: "Damage", color: "#F76767" },
    { id: "3", name: "Preventive", color: "#D2DCE9" },
    { id: "4", name: "Corrective", color: "#00246A" },
    { id: "5", name: "Upgrade", color: "#A5A5A5" },
    { id: "6", name: "Inspection", color: "#B0DD69" },
    { id: "7", name: "Safety", color: "#EFCB51" },
    { id: "8", name: "Other", color: "#333333" },
  ];

  const handleChangeSelection = (item) => {
    setTypeOfMaintenance(item);
    setShowModal(!showModal);
  };
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Workorders-Add").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const dispatch = useDispatch();

  const [showAddMainteneceTypePopup, setShowMaintenanaceTypePopup] =
    useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const [selectedColor, setSelectedColor] = useState("");
  const [maintenanceName, setMaintenanceName] = useState("");

  const [isNameError, setIsNameError] = useState(false);
  const [isColorError, setIsColorError] = useState(false);

  const handleColorChange = (color) => {
    setSelectedColor(color.hex);
  };

  const AddNewAssetType = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    setIsNameError(!maintenanceName);
    setIsColorError(!selectedColor);

    if (!maintenanceName || !selectedColor) return;

    postNewAssetTypeData();
  };

  const postNewAssetTypeData = async () => {
    let data = {
      name: maintenanceName,
      colorCode: selectedColor,
    };

    let response = await AddNewMaintenanceType(data);

    if (response) {
      dispatch(MaintainaceTypeList());

      setShowMaintenanaceTypePopup(false);
      setShowPicker(false);
      setSelectedColor("");
      setMaintenanceName("");
      setIsNameError(false);
      setIsColorError(false);
    }
  };

  return (
    <Container>
      <div className="add_group_wrap">
        <div
          className="groupManagerPopup show"
          style={{ marginTop: "40px", marginLeft: "-20px" }}
        >
          <div className="group_popup_inner">
            <div className="group_popup_header">
              <div className="title_wrap">
                <Flex gap="small" className="flex">
                  <h6>
                    <strong>
                      {/* Maintenance Type */}
                      {t("Maintenance Type")}
                    </strong>
                  </h6>
                  <div className="search_input">
                    <input
                      type="text"
                      // placeholder="Search"
                      placeholder={t("Search")}
                    />
                    <Button
                      type="text"
                      shape="circle"
                      icon={<SearchOutlined />}
                    />
                  </div>
                </Flex>
              </div>
              <div className="close_btn_wrap">
                <Button
                  type="text"
                  shape="circle"
                  icon={<CloseCircleOutlined />}
                  onClick={() => setShowModal(false)}
                />
              </div>
            </div>
            <div className="popup_body">
              <div className="group-table-wrapper">
                <Button
                  onClick={() => {
                    setShowMaintenanaceTypePopup(true);
                    setSelectedColor("");
                    setMaintenanceName("");
                    setSelectedColor("");
                    setIsColorError(false);
                    setIsNameError(false);
                  }}
                  type="text"
                  icon={<PlusCircleFilled style={{ color: "#95a7c6" }} />}
                >
                  {/* Add New */}
                  {t("Add New")}
                </Button>
                <List
                  itemLayout="horizontal"
                  dataSource={sortBy(maintenanceTypeList, ["name"])}
                  renderItem={(item) => (
                    <List.Item
                      onClick={() => {
                        handleChangeSelection(item);
                      }}
                    >
                      <Skeleton
                        avatar
                        title={false}
                        loading={item.loading}
                        active
                      >
                        <List.Item.Meta
                          title={item.name}
                          key={item.id}
                          id={item.id}
                        />
                        <div
                          style={{
                            backgroundColor: `${item.colorCode}`,
                            width: "13px",
                            height: "13px",
                            borderRadius: "50px",
                          }}
                        ></div>
                      </Skeleton>
                    </List.Item>
                  )}
                />
                {/* <Table columns={groupTableColumn} dataSource={GroupData} /> */}
              </div>
            </div>
          </div>
        </div>
        {showAddMainteneceTypePopup && (
          <div className="add-maintenance">
            <div style={{ display: "flex", float: "inline-end" }}>
              <Button
                type="text"
                shape="circle"
                icon={<CloseCircleOutlined />}
                onClick={() => setShowMaintenanaceTypePopup(false)}
              />
            </div>
            <br></br>
            <div className="ms-1 mt-2 d-flex">
              <div className="maintenance-type-wrapper maintenance-ascInput">
                <label className="maintenance-type-asc-label-top maintenance-type-asc-label-title">
                  {/* Item Name */}
                  {/* Maintenannce Name */}
                  {t("Maintenannce Name")}
                </label>
                <input
                  type="text"
                  className={
                    isNameError
                      ? "maintenance-type-item-id-input-error w-75 ps-2"
                      : "ms-2 maintenance-type-item-id-input w-75 ps-2"
                  }
                  name="Maintenance name"
                  onBlur={(evt) => {
                    setMaintenanceName(evt.target.value);
                  }}
                />
              </div>

              <div className="maintenance-type-wrapper maintenance-ascInput ms-2">
                <label className="maintenance-type-asc-label-top maintenance-type-asc-label-title">
                  {/* Item Name */}
                  {/* Color */}
                  {t("Color")}
                </label>
                <input
                  type="text"
                  className={
                    isColorError
                      ? "maintenance-type-item-id-input-error width-8 ps-2"
                      : "ms-2 maintenance-type-item-id-input width-8 ps-2"
                  }
                  name="Maintenance name"
                  onClick={() => {
                    setShowPicker(true);
                  }}
                />
                {selectedColor && (
                  <div
                    className="selected-color"
                    onClick={() => {
                      setShowPicker(true);
                    }}
                    style={{ backgroundColor: selectedColor }}
                  ></div>
                )}

                {!selectedColor && (
                  <img
                    src={plusDottedIcon}
                    alt="Plus Icon"
                    className="products-and-parts-plus-dotted-icon-general"
                    style={{ left: "45px" }}
                    onClick={() => setShowPicker(true)}
                  />
                )}
              </div>
            </div>
            {showPicker && (
              <div style={{ position: "absolute", left: "27vw", top: "0vh" }}>
                <SketchPicker
                  presetColors={[]}
                  color={selectedColor}
                  onChange={handleColorChange}
                />

                {selectedColor && (
                  <button
                    onClick={() => {
                      setShowPicker(false);
                    }}
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "#00246A",
                      color: "#fff",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    {/* Add */}
                    {t("Add")}
                  </button>
                )}
              </div>
            )}

            <div className="confirm-btn-div">
              <button className="confirm-btn" onClick={AddNewAssetType}>
                {/* Confirm */}
                {t("Confirm")}
              </button>
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};
